import { useState } from 'react';

const useArrayPush = () => {
    const [array, setArray] = useState([]);
    const pushToArray = (element) => {
        setArray((prevArray) => (prevArray ? [...prevArray, element] : [element]));
    };
    return [array, pushToArray];
};

export { useArrayPush as default };
//# sourceMappingURL=use-array-push.js.map
